// Claus d'UI fixes. Les claus amb punt (p.ex. 'field.title') són planes: t() fa
// messages[lang][key] amb la cadena sencera. El bloc "Widget Studio" (editor/type/tab/
// sec/field/fmt/opt/tip/err) alimenta l'editor dirigit per esquema.

const editor_ca = {
  // Studio / toolbar / navegador
  'editor.title': 'Editor de gràfics',
  'editor.back': 'Tornar',
  'editor.reset': 'Defecte',
  'editor.save': 'Desa',
  'editor.type': 'Tipus de widget',
  'editor.selectWidget': 'Selecciona un widget per editar-lo.',
  'editor.previewEmpty': 'La previsualització apareixerà aquí.',
  'editor.noFieldsTab': 'Cap camp en aquesta pestanya.',
  'editor.screens': 'Pantalles', 'editor.widgets': 'Widgets',
  'editor.addScreen': 'Afegir pantalla', 'editor.addWidget': 'Afegir widget',
  'editor.noWidgets': 'Cap widget encara.',
  'editor.moveUp': 'Amunt', 'editor.moveDown': 'Avall', 'editor.delete': 'Elimina',
  // Preview
  'editor.previewUnauthorized': 'Token no vàlid o caducat (401).',
  'editor.previewError': 'No s\'han pogut carregar les dades.',
  'editor.previewPercentNote': 'El % es calcula amb el KPI total de la pantalla; aquí es mostra el numerador.',
  'editor.previewPresenceNote': 'La presència necessita el total del segment; la previsualització pot ser parcial.',
  // JSON
  'editor.jsonTitle': 'JSON del widget',
  'editor.jsonHint': 'Edita el JSON i surt del camp per aplicar-ho al formulari i la previsualització.',
  // Editors d\'array
  'editor.addColor': 'Afegir color',
  'editor.withMetrics': 'Amb agregacions numèriques (SUM / AVG / MIN / MAX)',
  'editor.noNumericFields': 'No hi ha camps numèrics. Comprova el Segment ID i que hi hagi projeccions de tipus number.',
  'editor.numericField': 'Camp numèric', 'editor.removeField': 'Treu el camp', 'editor.addField': 'Afegir camp',
  'editor.columnField': 'Camp', 'editor.columnLabel': 'Etiqueta', 'editor.noColumns': 'Cap columna.', 'editor.addColumn': 'Afegir columna',
  'editor.levelConcat': 'Concatenar', 'editor.levelYear': 'Any (data)', 'editor.levelDomain': 'Domini', 'editor.levelPlain': 'Camp',
  'editor.levelFields': 'Camps (separats per comes)', 'editor.levelJoiner': 'Separador', 'editor.levelFieldSingle': 'Camp',
  'editor.noLevels': 'Cap nivell.', 'editor.addLevel': 'Afegir nivell',
  'editor.kvKey': 'Camp', 'editor.kvValue': 'Valor', 'editor.addPair': 'Afegir parell',
  'editor.addDimension': 'Afegir dimensió', 'editor.removeDimension': 'Treu la dimensió', 'editor.noDimensions2': 'Cap dimensió.',
  'editor.autoMapCategory': 'Categoria: {dim}', 'editor.autoMapGroup': 'Grup: {dim}',
  // Pestanyes
  'tab.data': 'Dades', 'tab.format': 'Format', 'tab.interaction': 'Interaccions', 'tab.advanced': 'Avançat',
  // Tipus
  'type.bar': 'Barres', 'type.line': 'Línia', 'type.area': 'Àrea', 'type.donut': 'Donut', 'type.pie': 'Pastís',
  'type.table': 'Taula', 'type.kpi': 'KPI', 'type.pivot': 'Pivot', 'type.matrix': 'Matriu', 'type.tree': 'Arbre',
  'type.map': 'Mapa', 'type.worldMap': 'Mapamundi', 'type.list': 'Llista', 'type.text': 'Text',
  // Seccions
  'sec.general': 'General', 'sec.data': 'Dades', 'sec.metrics': 'Agregacions numèriques', 'sec.chart': 'Gràfic',
  'sec.columns': 'Columnes', 'sec.interaction': 'Interaccions', 'sec.kpi': 'Paràmetres KPI', 'sec.map': 'Mapa',
  'sec.worldMap': 'Mapamundi', 'sec.pivot': 'Taula', 'sec.tree': 'Arbre', 'sec.text': 'Text', 'sec.list': 'Llista',
  // Camps
  'field.id': 'ID', 'field.width': 'Amplada', 'field.dataSourceKey': 'Clau de dades', 'field.active': 'Actiu',
  'field.segmentId': 'Segment ID', 'field.dimension': 'Dimensió', 'field.mapValue': 'Mapping: valor',
  'field.mapCategory': 'Mapping: categoria', 'field.mapGroup': 'Mapping: grup (2a dimensió)',
  'field.staticFilter': 'Filtre fix', 'field.includeMissing': 'Incloure "sense dada"', 'field.missingLabel': 'Etiqueta "sense dada"',
  'field.multiSep': 'Separador multi-valor', 'field.dateBucket': 'Agrupació de data', 'field.sortBy': 'Ordenació',
  'field.metrics': 'Agregacions', 'field.euro': 'Format euros (€)', 'field.title': 'Títol', 'field.colors': 'Colors',
  'field.horizontal': 'Barres horitzontals', 'field.stacked': 'Apilat', 'field.columnWidth': 'Amplada de columna',
  'field.distributed': 'Colors per categoria', 'field.height': 'Alçada', 'field.heightPerCat': 'Alçada per categoria',
  'field.minHeight': 'Alçada mínima', 'field.maxHeight': 'Alçada màxima', 'field.toolbar': 'Barra d\'eines',
  'field.legendShow': 'Mostrar llegenda', 'field.legendPos': 'Posició de la llegenda', 'field.legendMaxChars': 'Màx. caràcters llegenda',
  'field.xFormatter': 'Format eix X', 'field.yFormatter': 'Format eix Y', 'field.allowTypeChange': 'Permetre canvi de tipus',
  'field.columns': 'Columnes', 'field.cfTarget': 'Cross-filter: widget destí', 'field.cfField': 'Cross-filter: camp',
  'field.drilldown': 'Drilldown (dimensions)', 'field.valueKey': 'Clau del valor', 'field.kpiCountOf': 'Comptar valor',
  'field.kpiCountNotOf': 'Comptar excepte', 'field.kpiPercentOf': '% del valor', 'field.kpiPercentAny': '% amb qualsevol valor',
  'field.kpiRatioScope': 'Ràtio: àmbit', 'field.kpiRatioTarget': 'Ràtio: objectiu', 'field.presence': 'Donut de presència',
  'field.presenceLabels': 'Etiquetes presència', 'field.lineBreak': 'Salt de línia', 'field.kpiMetricOnly': 'Només l\'agregada',
  'field.kpiHideMetric': 'Amaga l\'agregada', 'field.subtitle': 'Subtítol', 'field.mapKeyField': 'Camp clau del mapa',
  'field.dataKeyField': 'Camp clau de dades', 'field.valueField': 'Camp de valor', 'field.countryLabel': 'Etiqueta país',
  'field.valueLabel': 'Etiqueta valor', 'field.rowLabel': 'Etiqueta fila', 'field.levels': 'Nivells', 'field.body': 'Cos',
  // Formatadors i opcions
  'fmt.default': '(Per defecte)', 'fmt.thousands': 'Milers (1K)', 'fmt.millions': 'Milions (1.2M)', 'fmt.raw': 'Cru',
  'opt.default': '(Per defecte)', 'opt.none': '(Cap)', 'opt.sortValue': 'Per valor', 'opt.sortCategory': 'Per categoria',
  'opt.sortTotal': 'Per total', 'opt.year': 'Any', 'opt.month': 'Mes', 'opt.top': 'Dalt', 'opt.right': 'Dreta',
  'opt.bottom': 'Baix', 'opt.left': 'Esquerra',
  // Tooltips
  'tip.dataSourceKey': 'Clau sota la qual es guarden les dades d\'aquest widget.',
  'tip.staticFilter': 'Filtre fix aplicat sempre (p.ex. categoria = Consumidor).',
  'tip.multiSep': 'Per camps multi-resposta (p.ex. "|en|es|"): parteix i compta cada token.',
  'tip.cfTarget': 'Clau de dades del widget que es filtrarà en clicar aquest.',
  'tip.drilldown': 'Llista de dimensions per fer drill-down / stack / breakdown.',
  'tip.valueKey': 'Clau on es guarda el valor calculat del KPI.',
  'tip.dimensionAuto': 'La 1a dimensió es mapeja com a categoria (eix); la 2a (si l\'afegeixes) com a grup, per a barres apilades o agrupades.',
  'tip.stackedNeeds2Dims': 'Cal una 2a dimensió (grup) perquè apilar tingui efecte.',
  // Errors
  'err.required': 'Camp obligatori', 'err.hexColor': 'Color hex no vàlid (#rgb o #rrggbb)',
  'err.integer': 'Ha de ser un enter', 'err.nonNegative': 'Ha de ser un número ≥ 0'
};

const editor_es = {
  'editor.title': 'Editor de gráficos', 'editor.back': 'Volver', 'editor.reset': 'Defecto', 'editor.save': 'Guardar',
  'editor.type': 'Tipo de widget', 'editor.selectWidget': 'Selecciona un widget para editarlo.',
  'editor.previewEmpty': 'La previsualización aparecerá aquí.', 'editor.noFieldsTab': 'Ningún campo en esta pestaña.',
  'editor.screens': 'Pantallas', 'editor.widgets': 'Widgets', 'editor.addScreen': 'Añadir pantalla',
  'editor.addWidget': 'Añadir widget', 'editor.noWidgets': 'Ningún widget aún.',
  'editor.moveUp': 'Arriba', 'editor.moveDown': 'Abajo', 'editor.delete': 'Eliminar',
  'editor.previewUnauthorized': 'Token no válido o caducado (401).',
  'editor.previewError': 'No se pudieron cargar los datos.',
  'editor.previewPercentNote': 'El % se calcula con el KPI total de la pantalla; aquí se muestra el numerador.',
  'editor.previewPresenceNote': 'La presencia necesita el total del segmento; la previsualización puede ser parcial.',
  'editor.jsonTitle': 'JSON del widget',
  'editor.jsonHint': 'Edita el JSON y sal del campo para aplicarlo al formulario y la previsualización.',
  'editor.addColor': 'Añadir color',
  'editor.withMetrics': 'Con agregaciones numéricas (SUM / AVG / MIN / MAX)',
  'editor.noNumericFields': 'No hay campos numéricos. Comprueba el Segment ID y que haya proyecciones de tipo number.',
  'editor.numericField': 'Campo numérico', 'editor.removeField': 'Quitar campo', 'editor.addField': 'Añadir campo',
  'editor.columnField': 'Campo', 'editor.columnLabel': 'Etiqueta', 'editor.noColumns': 'Ninguna columna.', 'editor.addColumn': 'Añadir columna',
  'editor.levelConcat': 'Concatenar', 'editor.levelYear': 'Año (fecha)', 'editor.levelDomain': 'Dominio', 'editor.levelPlain': 'Campo',
  'editor.levelFields': 'Campos (separados por comas)', 'editor.levelJoiner': 'Separador', 'editor.levelFieldSingle': 'Campo',
  'editor.noLevels': 'Ningún nivel.', 'editor.addLevel': 'Añadir nivel',
  'editor.kvKey': 'Campo', 'editor.kvValue': 'Valor', 'editor.addPair': 'Añadir par',
  'editor.addDimension': 'Añadir dimensión', 'editor.removeDimension': 'Quitar la dimensión', 'editor.noDimensions2': 'Ninguna dimensión.',
  'editor.autoMapCategory': 'Categoría: {dim}', 'editor.autoMapGroup': 'Grupo: {dim}',
  'tab.data': 'Datos', 'tab.format': 'Formato', 'tab.interaction': 'Interacciones', 'tab.advanced': 'Avanzado',
  'type.bar': 'Barras', 'type.line': 'Línea', 'type.area': 'Área', 'type.donut': 'Donut', 'type.pie': 'Tarta',
  'type.table': 'Tabla', 'type.kpi': 'KPI', 'type.pivot': 'Pivot', 'type.matrix': 'Matriz', 'type.tree': 'Árbol',
  'type.map': 'Mapa', 'type.worldMap': 'Mapamundi', 'type.list': 'Lista', 'type.text': 'Texto',
  'sec.general': 'General', 'sec.data': 'Datos', 'sec.metrics': 'Agregaciones numéricas', 'sec.chart': 'Gráfico',
  'sec.columns': 'Columnas', 'sec.interaction': 'Interacciones', 'sec.kpi': 'Parámetros KPI', 'sec.map': 'Mapa',
  'sec.worldMap': 'Mapamundi', 'sec.pivot': 'Tabla', 'sec.tree': 'Árbol', 'sec.text': 'Texto', 'sec.list': 'Lista',
  'field.id': 'ID', 'field.width': 'Ancho', 'field.dataSourceKey': 'Clave de datos', 'field.active': 'Activo',
  'field.segmentId': 'Segment ID', 'field.dimension': 'Dimensión', 'field.mapValue': 'Mapping: valor',
  'field.mapCategory': 'Mapping: categoría', 'field.mapGroup': 'Mapping: grupo (2ª dimensión)',
  'field.staticFilter': 'Filtro fijo', 'field.includeMissing': 'Incluir "sin dato"', 'field.missingLabel': 'Etiqueta "sin dato"',
  'field.multiSep': 'Separador multi-valor', 'field.dateBucket': 'Agrupación de fecha', 'field.sortBy': 'Orden',
  'field.metrics': 'Agregaciones', 'field.euro': 'Formato euros (€)', 'field.title': 'Título', 'field.colors': 'Colores',
  'field.horizontal': 'Barras horizontales', 'field.stacked': 'Apilado', 'field.columnWidth': 'Ancho de columna',
  'field.distributed': 'Colores por categoría', 'field.height': 'Altura', 'field.heightPerCat': 'Altura por categoría',
  'field.minHeight': 'Altura mínima', 'field.maxHeight': 'Altura máxima', 'field.toolbar': 'Barra de herramientas',
  'field.legendShow': 'Mostrar leyenda', 'field.legendPos': 'Posición de la leyenda', 'field.legendMaxChars': 'Máx. caracteres leyenda',
  'field.xFormatter': 'Formato eje X', 'field.yFormatter': 'Formato eje Y', 'field.allowTypeChange': 'Permitir cambio de tipo',
  'field.columns': 'Columnas', 'field.cfTarget': 'Cross-filter: widget destino', 'field.cfField': 'Cross-filter: campo',
  'field.drilldown': 'Drilldown (dimensiones)', 'field.valueKey': 'Clave del valor', 'field.kpiCountOf': 'Contar valor',
  'field.kpiCountNotOf': 'Contar excepto', 'field.kpiPercentOf': '% del valor', 'field.kpiPercentAny': '% con cualquier valor',
  'field.kpiRatioScope': 'Ratio: ámbito', 'field.kpiRatioTarget': 'Ratio: objetivo', 'field.presence': 'Donut de presencia',
  'field.presenceLabels': 'Etiquetas presencia', 'field.lineBreak': 'Salto de línea', 'field.kpiMetricOnly': 'Solo la agregada',
  'field.kpiHideMetric': 'Ocultar la agregada', 'field.subtitle': 'Subtítulo', 'field.mapKeyField': 'Campo clave del mapa',
  'field.dataKeyField': 'Campo clave de datos', 'field.valueField': 'Campo de valor', 'field.countryLabel': 'Etiqueta país',
  'field.valueLabel': 'Etiqueta valor', 'field.rowLabel': 'Etiqueta fila', 'field.levels': 'Niveles', 'field.body': 'Cuerpo',
  'fmt.default': '(Por defecto)', 'fmt.thousands': 'Miles (1K)', 'fmt.millions': 'Millones (1.2M)', 'fmt.raw': 'Crudo',
  'opt.default': '(Por defecto)', 'opt.none': '(Ninguno)', 'opt.sortValue': 'Por valor', 'opt.sortCategory': 'Por categoría',
  'opt.sortTotal': 'Por total', 'opt.year': 'Año', 'opt.month': 'Mes', 'opt.top': 'Arriba', 'opt.right': 'Derecha',
  'opt.bottom': 'Abajo', 'opt.left': 'Izquierda',
  'tip.dataSourceKey': 'Clave bajo la que se guardan los datos de este widget.',
  'tip.staticFilter': 'Filtro fijo aplicado siempre (p.ej. categoría = Consumidor).',
  'tip.multiSep': 'Para campos multi-respuesta (p.ej. "|en|es|"): parte y cuenta cada token.',
  'tip.cfTarget': 'Clave de datos del widget que se filtrará al hacer clic en este.',
  'tip.drilldown': 'Lista de dimensiones para drill-down / stack / breakdown.',
  'tip.valueKey': 'Clave donde se guarda el valor calculado del KPI.',
  'tip.dimensionAuto': 'La 1ª dimensión se mapea como categoría (eje); la 2ª (si la añades) como grupo, para barras apiladas o agrupadas.',
  'tip.stackedNeeds2Dims': 'Falta una 2ª dimensión (grupo) para que apilar tenga efecto.',
  'err.required': 'Campo obligatorio', 'err.hexColor': 'Color hex no válido (#rgb o #rrggbb)',
  'err.integer': 'Debe ser un entero', 'err.nonNegative': 'Debe ser un número ≥ 0'
};

const editor_en = {
  'editor.title': 'Chart editor', 'editor.back': 'Back', 'editor.reset': 'Default', 'editor.save': 'Save',
  'editor.type': 'Widget type', 'editor.selectWidget': 'Select a widget to edit it.',
  'editor.previewEmpty': 'The preview will appear here.', 'editor.noFieldsTab': 'No fields in this tab.',
  'editor.screens': 'Screens', 'editor.widgets': 'Widgets', 'editor.addScreen': 'Add screen',
  'editor.addWidget': 'Add widget', 'editor.noWidgets': 'No widgets yet.',
  'editor.moveUp': 'Up', 'editor.moveDown': 'Down', 'editor.delete': 'Delete',
  'editor.previewUnauthorized': 'Invalid or expired token (401).',
  'editor.previewError': 'Could not load data.',
  'editor.previewPercentNote': 'The % uses the screen total KPI; the numerator is shown here.',
  'editor.previewPresenceNote': 'Presence needs the segment total; the preview may be partial.',
  'editor.jsonTitle': 'Widget JSON',
  'editor.jsonHint': 'Edit the JSON and blur the field to apply it to the form and preview.',
  'editor.addColor': 'Add colour',
  'editor.withMetrics': 'With numeric aggregations (SUM / AVG / MIN / MAX)',
  'editor.noNumericFields': 'No numeric fields. Check the Segment ID and that number-type projections exist.',
  'editor.numericField': 'Numeric field', 'editor.removeField': 'Remove field', 'editor.addField': 'Add field',
  'editor.columnField': 'Field', 'editor.columnLabel': 'Label', 'editor.noColumns': 'No columns.', 'editor.addColumn': 'Add column',
  'editor.levelConcat': 'Concatenate', 'editor.levelYear': 'Year (date)', 'editor.levelDomain': 'Domain', 'editor.levelPlain': 'Field',
  'editor.levelFields': 'Fields (comma-separated)', 'editor.levelJoiner': 'Joiner', 'editor.levelFieldSingle': 'Field',
  'editor.noLevels': 'No levels.', 'editor.addLevel': 'Add level',
  'editor.kvKey': 'Field', 'editor.kvValue': 'Value', 'editor.addPair': 'Add pair',
  'editor.addDimension': 'Add dimension', 'editor.removeDimension': 'Remove dimension', 'editor.noDimensions2': 'No dimensions.',
  'editor.autoMapCategory': 'Category: {dim}', 'editor.autoMapGroup': 'Group: {dim}',
  'tab.data': 'Data', 'tab.format': 'Format', 'tab.interaction': 'Interactions', 'tab.advanced': 'Advanced',
  'type.bar': 'Bar', 'type.line': 'Line', 'type.area': 'Area', 'type.donut': 'Donut', 'type.pie': 'Pie',
  'type.table': 'Table', 'type.kpi': 'KPI', 'type.pivot': 'Pivot', 'type.matrix': 'Matrix', 'type.tree': 'Tree',
  'type.map': 'Map', 'type.worldMap': 'World map', 'type.list': 'List', 'type.text': 'Text',
  'sec.general': 'General', 'sec.data': 'Data', 'sec.metrics': 'Numeric aggregations', 'sec.chart': 'Chart',
  'sec.columns': 'Columns', 'sec.interaction': 'Interactions', 'sec.kpi': 'KPI parameters', 'sec.map': 'Map',
  'sec.worldMap': 'World map', 'sec.pivot': 'Table', 'sec.tree': 'Tree', 'sec.text': 'Text', 'sec.list': 'List',
  'field.id': 'ID', 'field.width': 'Width', 'field.dataSourceKey': 'Data key', 'field.active': 'Active',
  'field.segmentId': 'Segment ID', 'field.dimension': 'Dimension', 'field.mapValue': 'Mapping: value',
  'field.mapCategory': 'Mapping: category', 'field.mapGroup': 'Mapping: group (2nd dimension)',
  'field.staticFilter': 'Static filter', 'field.includeMissing': 'Include "missing"', 'field.missingLabel': '"Missing" label',
  'field.multiSep': 'Multi-value separator', 'field.dateBucket': 'Date bucket', 'field.sortBy': 'Sort by',
  'field.metrics': 'Aggregations', 'field.euro': 'Euro format (€)', 'field.title': 'Title', 'field.colors': 'Colours',
  'field.horizontal': 'Horizontal bars', 'field.stacked': 'Stacked', 'field.columnWidth': 'Column width',
  'field.distributed': 'Colour per category', 'field.height': 'Height', 'field.heightPerCat': 'Height per category',
  'field.minHeight': 'Min height', 'field.maxHeight': 'Max height', 'field.toolbar': 'Toolbar',
  'field.legendShow': 'Show legend', 'field.legendPos': 'Legend position', 'field.legendMaxChars': 'Legend max chars',
  'field.xFormatter': 'X axis format', 'field.yFormatter': 'Y axis format', 'field.allowTypeChange': 'Allow type change',
  'field.columns': 'Columns', 'field.cfTarget': 'Cross-filter: target widget', 'field.cfField': 'Cross-filter: field',
  'field.drilldown': 'Drilldown (dimensions)', 'field.valueKey': 'Value key', 'field.kpiCountOf': 'Count value',
  'field.kpiCountNotOf': 'Count except', 'field.kpiPercentOf': '% of value', 'field.kpiPercentAny': '% with any value',
  'field.kpiRatioScope': 'Ratio: scope', 'field.kpiRatioTarget': 'Ratio: target', 'field.presence': 'Presence donut',
  'field.presenceLabels': 'Presence labels', 'field.lineBreak': 'Line break', 'field.kpiMetricOnly': 'Only aggregate',
  'field.kpiHideMetric': 'Hide aggregate', 'field.subtitle': 'Subtitle', 'field.mapKeyField': 'Map key field',
  'field.dataKeyField': 'Data key field', 'field.valueField': 'Value field', 'field.countryLabel': 'Country label',
  'field.valueLabel': 'Value label', 'field.rowLabel': 'Row label', 'field.levels': 'Levels', 'field.body': 'Body',
  'fmt.default': '(Default)', 'fmt.thousands': 'Thousands (1K)', 'fmt.millions': 'Millions (1.2M)', 'fmt.raw': 'Raw',
  'opt.default': '(Default)', 'opt.none': '(None)', 'opt.sortValue': 'By value', 'opt.sortCategory': 'By category',
  'opt.sortTotal': 'By total', 'opt.year': 'Year', 'opt.month': 'Month', 'opt.top': 'Top', 'opt.right': 'Right',
  'opt.bottom': 'Bottom', 'opt.left': 'Left',
  'tip.dataSourceKey': 'Key under which this widget\'s data is stored.',
  'tip.staticFilter': 'Fixed filter always applied (e.g. category = Consumer).',
  'tip.multiSep': 'For multi-response fields (e.g. "|en|es|"): split and count each token.',
  'tip.cfTarget': 'Data key of the widget filtered when clicking this one.',
  'tip.drilldown': 'List of dimensions for drill-down / stack / breakdown.',
  'tip.valueKey': 'Key where the computed KPI value is stored.',
  'tip.dimensionAuto': 'The 1st dimension maps to category (axis); the 2nd (if added) maps to group, for stacked or grouped bars.',
  'tip.stackedNeeds2Dims': 'A 2nd dimension (group) is needed for stacking to have any effect.',
  'err.required': 'Required field', 'err.hexColor': 'Invalid hex colour (#rgb or #rrggbb)',
  'err.integer': 'Must be an integer', 'err.nonNegative': 'Must be a number ≥ 0'
};

export default {
  ca_es: {
    loadingDimensions: 'Carregant dimensions...',
    noDimensions: 'No hi ha dimensions disponibles',
    noResults: 'No s\'ha trobat cap dimensió',
    searchPlaceholder: 'Cercar dimensió...',
    viewTable: 'Veure taula',
    viewChart: 'Veure gràfic',
    viewMap: 'Veure mapa',
    exportXlsx: 'Exportar XLSX',
    exportPdf: 'Exportar a PDF',
    openConfig: 'Obrir editor de configuració',
    pdfModalTitle: 'Opcions d\'exportació PDF',
    pdfOrientation: 'Orientació',
    pdfPortrait: 'Vertical (Portrait)',
    pdfLandscape: 'Horitzontal (Landscape)',
    pdfQuality: 'Qualitat',
    pdfQualityLow: 'Baixa (més ràpid)',
    pdfQualityMedium: 'Mitjana',
    pdfQualityHigh: 'Alta (més detall)',
    pdfIncludeKpi: 'Incloure KPI widgets',
    pdfHideButtons: 'Amagar botons de taula',
    pdfFitToPage: 'Ajustar a pàgina',
    cancel: 'Cancel·lar',
    export: 'Exportar',
    errorNoBaseUrl: 'URL base no configurada. Introdueix la URL de l\'API al panell de configuració.',
    errorUnauthorized: 'Token no vàlid o caducat (401). Introdueix un bearer vàlid al panell de configuració.',
    drillMode: 'Drill down',
    multiMode: 'Stack',
    cumulativeMode: 'Breakdown',
    ...editor_ca
  },
  es_es: {
    loadingDimensions: 'Cargando dimensiones...',
    noDimensions: 'No hay dimensiones disponibles',
    noResults: 'No se ha encontrado ninguna dimensión',
    searchPlaceholder: 'Buscar dimensión...',
    viewTable: 'Ver tabla',
    viewChart: 'Ver gráfico',
    viewMap: 'Ver mapa',
    exportXlsx: 'Exportar XLSX',
    exportPdf: 'Exportar a PDF',
    openConfig: 'Abrir editor de configuración',
    pdfModalTitle: 'Opciones de exportación PDF',
    pdfOrientation: 'Orientación',
    pdfPortrait: 'Vertical (Portrait)',
    pdfLandscape: 'Horizontal (Landscape)',
    pdfQuality: 'Calidad',
    pdfQualityLow: 'Baja (más rápido)',
    pdfQualityMedium: 'Media',
    pdfQualityHigh: 'Alta (más detalle)',
    pdfIncludeKpi: 'Incluir KPI widgets',
    pdfHideButtons: 'Ocultar botones de tabla',
    pdfFitToPage: 'Ajustar a página',
    cancel: 'Cancelar',
    export: 'Exportar',
    errorNoBaseUrl: 'URL base no configurada. Introduce la URL de la API en el panel de configuración.',
    errorUnauthorized: 'Token no válido o caducado (401). Introduce un bearer válido en el panel de configuración.',
    drillMode: 'Drill down',
    multiMode: 'Stack',
    cumulativeMode: 'Breakdown',
    ...editor_es
  },
  en_gb: {
    loadingDimensions: 'Loading dimensions...',
    noDimensions: 'No dimensions available',
    noResults: 'No dimensions found',
    searchPlaceholder: 'Search dimension...',
    viewTable: 'View table',
    viewChart: 'View chart',
    viewMap: 'View map',
    exportXlsx: 'Export XLSX',
    exportPdf: 'Export to PDF',
    openConfig: 'Open configuration editor',
    pdfModalTitle: 'PDF export options',
    pdfOrientation: 'Orientation',
    pdfPortrait: 'Portrait (Vertical)',
    pdfLandscape: 'Landscape (Horizontal)',
    pdfQuality: 'Quality',
    pdfQualityLow: 'Low (faster)',
    pdfQualityMedium: 'Medium',
    pdfQualityHigh: 'High (more detail)',
    pdfIncludeKpi: 'Include KPI widgets',
    pdfHideButtons: 'Hide table buttons',
    pdfFitToPage: 'Fit to page',
    cancel: 'Cancel',
    export: 'Export',
    errorNoBaseUrl: 'Base URL not configured. Enter the API URL in the configuration panel.',
    errorUnauthorized: 'Invalid or expired token (401). Enter a valid bearer in the configuration panel.',
    drillMode: 'Drill down',
    multiMode: 'Stack',
    cumulativeMode: 'Breakdown',
    ...editor_en
  }
}
